/**
 * Fase 2 (W8): textos da compra direta, do modo de operação de Compras e do aviso de histórico. Somados ao `i18n.ts` do
 * módulo no `index.tsx`. Sem travessão e sem emoji; o es usa "tú".
 */
const pt = {
  abaCompras: 'Compras',
  modos: {
    usos: {
      requisicoes_one: '{{n}} requisição de compra em andamento',
      requisicoes_other: '{{n}} requisições de compra em andamento',
      pedidos_one: '{{n}} pedido de compra em andamento',
      pedidos_other: '{{n}} pedidos de compra em andamento',
    },
    modo: {
      titulo: 'Compras',
      simplificado: {
        nome: 'Simplificado',
        descricao: 'Só a compra direta: fornecedor, nota fiscal, itens ou total e parcelas, em um passo. As contas a pagar nascem ao salvar.',
      },
      detalhado: {
        nome: 'Detalhado',
        descricao: 'A compra direta continua e entram requisição com aprovação, cotação e comparativo, pedido, recebimento e preços por fornecedor.',
      },
    },
  },
  compra: {
    nova: 'Nova compra',
    titulo: 'Compra {{numero}}',
    tituloCurto: 'Compra',
    total: 'Total da compra',
    fornecedor: 'Fornecedor',
    novoFornecedor: 'Novo fornecedor',
    descricao: 'Descrição',
    competencia: 'Competência',
    nf: 'Nota fiscal',
    nfNumero: 'Número',
    nfSerie: 'Série',
    nfChave: 'Chave de acesso',
    nfEmissao: 'Emissão',
    detalharItens: 'Detalhar por itens',
    detalharItensAjuda: 'Com itens, cada um leva categoria e centro de custo próprios',
    valorTotal: 'Valor total',
    categoria: 'Categoria',
    centroCusto: 'Centro de custo',
    semFinanceiro: 'Categoria e centro de custo pedem acesso de leitura ao Financeiro',
    servico: 'Serviço do catálogo (opcional)',
    servicoContratado: 'Serviço contratado (opcional)',
    itemDescricao: 'Descrição do item',
    quantidade: 'Quantidade',
    valorUnitario: 'Valor unitário',
    totalItem: 'Total do item',
    adicionarItem: 'Adicionar item',
    removerItem: 'Remover item',
    somaItens: 'Soma dos itens',
    condicao: 'Condição',
    condicoes: { avista: 'À vista', mensal: 'Parcelas mensais', prazos: 'Prazos em dias' },
    parcelas: 'Parcelas',
    prazos: 'Prazos',
    prazosAjuda: '30, 30/60 ou 30/60/90: contados a partir do primeiro vencimento',
    primeiroVencimento: 'Primeiro vencimento',
    forma: 'Forma de pagamento',
    formas: { pix: 'Pix', boleto: 'Boleto', transferencia: 'Transferência', cartao_credito: 'Cartão de crédito', cartao_debito: 'Cartão de débito', dinheiro: 'Dinheiro', cheque: 'Cheque', outro: 'Outro' },
    observacoes: 'Observações',
    previa_one: '{{count}} conta a pagar: {{valores}}',
    previa_other: '{{count}} contas a pagar: {{valores}}',
    previaVazia: 'Informe o valor para ver as parcelas',
    salva: 'Compra registrada. As contas a pagar foram geradas.',
    contas: 'Contas a pagar geradas',
    parcela: 'Parcela {{parcela}} de {{parcelas}}',
    venceEm: 'vence em {{data}}',
    verNoContas: 'Ver no Contas a pagar',
    itens: 'Itens',
    semItens: 'Sem itens: a compra foi lançada pelo total.',
    cancelar: 'Cancelar compra',
    cancelarTitulo: 'Cancelar compra',
    cancelarTexto: 'As contas a pagar em aberto e sem baixa são canceladas. As que já têm baixa ficam como estão: corrija pelo estorno no Financeiro. Nada é apagado.',
    motivo: 'Motivo do cancelamento',
    excluir: 'Excluir compra',
    excluirTitulo: 'Excluir esta compra?',
    excluirTexto: 'A compra cancelada vai para a lixeira por 30 dias e pode voltar como estava. As contas a pagar dela no Contas não mudam.',
    excluida: 'Compra excluída. Dá para desfazer pela Lixeira em até 30 dias.',
    cancelada: 'Compra cancelada: {{canceladas}} conta(s) cancelada(s), {{mantidas}} com baixa mantida(s)',
    estado: { ativa: 'Ativa', cancelada: 'Cancelada' },
    estadoConta: { em_aberto: 'Em aberto', parcial: 'Paga em parte', pago: 'Paga', cancelado: 'Cancelada' },
    canceladaEm: 'Cancelada em',
    vazio: 'Registre aqui o que a empresa compra: serviço, material ou conta. As contas a pagar saem prontas.',
    vazioFiltro: 'Nenhuma compra com estes filtros.',
    todosEstados: 'Todos os estados',
    tipoFiltro: { rotulo: 'Tipo', todos: 'Produtos e serviços', produto: 'Produto', servico: 'Serviço' },
    erros: {
      fornecedor: 'Escolha o fornecedor',
      descricao: 'Descreva a compra',
      valor: 'Informe o valor total ou os itens',
      item: 'Descreva cada item e informe quantidade e valor',
    },
  },
  historico: {
    simplificado: 'Histórico do fluxo detalhado. No modo simplificado ele fica só para consulta; para usar requisição, cotação, pedido e recebimento, troque em Configurações > Modo de operação.',
    verHistorico: 'Ver histórico do fluxo detalhado',
    semEstoque: 'O Estoque não está instalado: o recebimento confirma o pedido e gera a conta a pagar, sem entrada de mercadoria no estoque.',
  },
  // Lote 09/10 (C3): o formulário da compra em áreas, na ordem e com os nomes do sistema antigo.
  c3: {
    tipo: 'Tipo da compra',
    tipos: { servico: 'Serviço (NFS-e)', produto: 'Produto (NF-e de entrada)' },
    tipoLista: { servico: 'Serviço', produto: 'Produto' },
    prestador: 'Prestador de serviço',
    emitente: 'Emitente (fornecedor)',
    empresa: 'Empresa',
    empresaAjuda: 'Para trocar, use o filtro de empresa no topo.',
    numeroCompra: 'Número da compra',
    numeroGerado: 'Gerado ao salvar',
    nfServico: 'Nota fiscal de serviço (NFS-e)',
    nfProduto: 'Nota fiscal de produto (NF-e)',
    nfNumero: 'Número da NF',
    nfEmissao: 'Data de emissão',
    discriminacaoServico: 'Discriminação do serviço',
    produtosItens: 'Produtos / itens',
    descricaoServico: 'Discriminação do serviço',
    descricaoProduto: 'Natureza da operação / descrição',
    servicoContratado: 'Serviço contratado',
    novoServicoContratado: 'Novo serviço',
    qtd: 'Qtd.',
    vlrUnit: 'Vlr. unit.',
    valor: 'Valor',
    valoresImpostos: 'Valores e impostos',
    impostosAviso: 'Os impostos não são detalhados: informe o valor total da nota.',
    datas: 'Datas',
    primeiroVencimento: '1º vencimento',
    condicoesPagamento: 'Condições de pagamento',
    duplicatas: 'Duplicatas / parcelamento',
    numeroParcelas: 'Número de parcelas',
    classificacao: 'Classificação financeira',
    planoContas: 'Plano de contas',
    contaBancaria: 'Conta bancária',
    contaBancariaAjuda: 'Vira a conta prevista nas contas a pagar e vem sugerida na baixa.',
    previa: { parcela: 'Parcela', vencimento: 'Vencimento', valor: 'Valor', total: 'Total' },
    entradaEstoque: 'Os itens com produto dão entrada no Estoque ao salvar (custo = valor unitário).',
    contaPrevista: 'Conta prevista',
    salvaEstoque: 'Compra registrada. As contas a pagar foram geradas e os produtos deram entrada no Estoque.',
    contratadoCriado: 'Serviço cadastrado e escolhido no item.',
  },
  w25: {
    forma: 'Forma de pagamento',
    minimo: 'Pedido mínimo',
    minimoInfo: 'Pedido mínimo deste fornecedor: {{valor}}.',
    minimoAviso: 'O total está abaixo do pedido mínimo deste fornecedor ({{valor}}). Dá para salvar assim mesmo.',
    condicoesNaFicha: 'As condições moram na ficha do fornecedor em Cadastros; editar aqui ou lá muda o mesmo dado.',
    produto: 'Produto',
    novoServico: 'Novo serviço',
    novoProduto: 'Novo produto',
    servicoCriado: 'Serviço cadastrado no catálogo e escolhido no item.',
    produtoCriado: 'Produto cadastrado no Estoque e escolhido no item.',
    semEstoqueRecebimento: 'Sem o Estoque, nada entra no estoque: o recebimento confirma o pedido e gera a conta a pagar.',
  },
};

const en: typeof pt = {
  abaCompras: 'Purchases',
  modos: {
    usos: {
      requisicoes_one: '{{n}} purchase requisition in progress',
      requisicoes_other: '{{n}} purchase requisitions in progress',
      pedidos_one: '{{n}} purchase order in progress',
      pedidos_other: '{{n}} purchase orders in progress',
    },
    modo: {
      titulo: 'Purchasing',
      simplificado: { nome: 'Simplified', descricao: 'Only the direct purchase: supplier, invoice, items or total and installments, in one step. Payables are created on save.' },
      detalhado: { nome: 'Detailed', descricao: 'The direct purchase stays and adds requisition with approval, quotes and comparison, order, receipt and prices per supplier.' },
    },
  },
  compra: {
    nova: 'New purchase',
    titulo: 'Purchase {{numero}}',
    tituloCurto: 'Purchase',
    total: 'Purchase total',
    fornecedor: 'Supplier',
    novoFornecedor: 'New supplier',
    descricao: 'Description',
    competencia: 'Accrual period',
    nf: 'Invoice',
    nfNumero: 'Number',
    nfSerie: 'Series',
    nfChave: 'Access key',
    nfEmissao: 'Issue date',
    detalharItens: 'Itemize',
    detalharItensAjuda: 'With items, each one has its own category and cost center',
    valorTotal: 'Total amount',
    categoria: 'Category',
    centroCusto: 'Cost center',
    semFinanceiro: 'Category and cost center need read access to Finance',
    servico: 'Catalog service (optional)',
    servicoContratado: 'Contracted service (optional)',
    itemDescricao: 'Item description',
    quantidade: 'Quantity',
    valorUnitario: 'Unit price',
    totalItem: 'Item total',
    adicionarItem: 'Add item',
    removerItem: 'Remove item',
    somaItens: 'Items total',
    condicao: 'Terms',
    condicoes: { avista: 'Upfront', mensal: 'Monthly installments', prazos: 'Terms in days' },
    parcelas: 'Installments',
    prazos: 'Terms',
    prazosAjuda: '30, 30/60 or 30/60/90: counted from the first due date',
    primeiroVencimento: 'First due date',
    forma: 'Payment method',
    formas: { pix: 'Pix', boleto: 'Bank slip', transferencia: 'Transfer', cartao_credito: 'Credit card', cartao_debito: 'Debit card', dinheiro: 'Cash', cheque: 'Check', outro: 'Other' },
    observacoes: 'Notes',
    previa_one: '{{count}} payable: {{valores}}',
    previa_other: '{{count}} payables: {{valores}}',
    previaVazia: 'Enter the amount to see the installments',
    salva: 'Purchase recorded. The payables were created.',
    contas: 'Payables created',
    parcela: 'Installment {{parcela}} of {{parcelas}}',
    venceEm: 'due {{data}}',
    verNoContas: 'View in Payables',
    itens: 'Items',
    semItens: 'No items: the purchase was posted by total.',
    cancelar: 'Cancel purchase',
    cancelarTitulo: 'Cancel purchase',
    cancelarTexto: 'Open payables without payment are cancelled. Those already paid stay as they are: fix them by reversing in Finance. Nothing is deleted.',
    motivo: 'Cancellation reason',
    excluir: 'Delete purchase',
    excluirTitulo: 'Delete this purchase?',
    excluirTexto: 'The cancelled purchase goes to the trash for 30 days and can come back as it was. Its payables in Accounts do not change.',
    excluida: 'Purchase deleted. You can undo it from the Trash within 30 days.',
    cancelada: 'Purchase cancelled: {{canceladas}} payable(s) cancelled, {{mantidas}} with payment kept',
    estado: { ativa: 'Active', cancelada: 'Cancelled' },
    estadoConta: { em_aberto: 'Open', parcial: 'Partly paid', pago: 'Paid', cancelado: 'Cancelled' },
    canceladaEm: 'Cancelled on',
    vazio: 'Record what the company buys here: service, material or bill. The payables come out ready.',
    vazioFiltro: 'No purchases with these filters.',
    todosEstados: 'All states',
    tipoFiltro: { rotulo: 'Type', todos: 'Products and services', produto: 'Product', servico: 'Service' },
    erros: {
      fornecedor: 'Choose the supplier',
      descricao: 'Describe the purchase',
      valor: 'Enter the total amount or the items',
      item: 'Describe each item and enter quantity and price',
    },
  },
  historico: {
    simplificado: 'History of the detailed flow. In simplified mode it is read only; to use requisition, quote, order and receipt, change it in Settings > Operating mode.',
    verHistorico: 'View detailed flow history',
    semEstoque: 'Inventory is not installed: the receipt confirms the order and creates the payable, with no goods entering stock.',
  },
  c3: {
    tipo: 'Purchase type',
    tipos: { servico: 'Service (service invoice)', produto: 'Product (incoming goods invoice)' },
    tipoLista: { servico: 'Service', produto: 'Product' },
    prestador: 'Service provider',
    emitente: 'Issuer (supplier)',
    empresa: 'Company',
    empresaAjuda: 'To change it, use the company filter at the top.',
    numeroCompra: 'Purchase number',
    numeroGerado: 'Generated on save',
    nfServico: 'Service invoice',
    nfProduto: 'Goods invoice',
    nfNumero: 'Invoice number',
    nfEmissao: 'Issue date',
    discriminacaoServico: 'Service description',
    produtosItens: 'Products / items',
    descricaoServico: 'Service description',
    descricaoProduto: 'Nature of operation / description',
    servicoContratado: 'Contracted service',
    novoServicoContratado: 'New service',
    qtd: 'Qty',
    vlrUnit: 'Unit price',
    valor: 'Amount',
    valoresImpostos: 'Amounts and taxes',
    impostosAviso: 'Taxes are not itemized: enter the invoice total.',
    datas: 'Dates',
    primeiroVencimento: '1st due date',
    condicoesPagamento: 'Payment terms',
    duplicatas: 'Installments',
    numeroParcelas: 'Number of installments',
    classificacao: 'Financial classification',
    planoContas: 'Chart of accounts',
    contaBancaria: 'Bank account',
    contaBancariaAjuda: 'Becomes the planned account on the payables and is suggested when paying.',
    previa: { parcela: 'Installment', vencimento: 'Due date', valor: 'Amount', total: 'Total' },
    entradaEstoque: 'Items with a product enter the Inventory on save (cost = unit price).',
    contaPrevista: 'Planned account',
    salvaEstoque: 'Purchase recorded. The payables were created and the products entered the Inventory.',
    contratadoCriado: 'Service created and selected on the item.',
  },
  w25: {
    forma: 'Payment method',
    minimo: 'Minimum order',
    minimoInfo: 'Minimum order for this supplier: {{valor}}.',
    minimoAviso: 'The total is below this supplier minimum order ({{valor}}). You can save anyway.',
    condicoesNaFicha: 'The terms live in the supplier record in Records; editing here or there changes the same data.',
    produto: 'Product',
    novoServico: 'New service',
    novoProduto: 'New product',
    servicoCriado: 'Service added to the catalog and chosen for the item.',
    produtoCriado: 'Product added to Inventory and chosen for the item.',
    semEstoqueRecebimento: 'Without Inventory, nothing enters stock: the receipt confirms the order and creates the payable.',
  },
};

const es: typeof pt = {
  abaCompras: 'Compras',
  modos: {
    usos: {
      requisicoes_one: '{{n}} requisición de compra en curso',
      requisicoes_other: '{{n}} requisiciones de compra en curso',
      pedidos_one: '{{n}} pedido de compra en curso',
      pedidos_other: '{{n}} pedidos de compra en curso',
    },
    modo: {
      titulo: 'Compras',
      simplificado: { nome: 'Simplificado', descricao: 'Solo la compra directa: proveedor, factura, ítems o total y cuotas, en un paso. Las cuentas por pagar nacen al guardar.' },
      detalhado: { nome: 'Detallado', descricao: 'La compra directa sigue y se suman requisición con aprobación, cotización y comparativo, pedido, recepción y precios por proveedor.' },
    },
  },
  compra: {
    nova: 'Nueva compra',
    titulo: 'Compra {{numero}}',
    tituloCurto: 'Compra',
    total: 'Total de la compra',
    fornecedor: 'Proveedor',
    novoFornecedor: 'Nuevo proveedor',
    descricao: 'Descripción',
    competencia: 'Período de devengo',
    nf: 'Factura',
    nfNumero: 'Número',
    nfSerie: 'Serie',
    nfChave: 'Clave de acceso',
    nfEmissao: 'Emisión',
    detalharItens: 'Detallar por ítems',
    detalharItensAjuda: 'Con ítems, cada uno lleva su propia categoría y centro de costo',
    valorTotal: 'Valor total',
    categoria: 'Categoría',
    centroCusto: 'Centro de costo',
    semFinanceiro: 'Categoría y centro de costo piden acceso de lectura a Finanzas',
    servico: 'Servicio del catálogo (opcional)',
    servicoContratado: 'Servicio contratado (opcional)',
    itemDescricao: 'Descripción del ítem',
    quantidade: 'Cantidad',
    valorUnitario: 'Valor unitario',
    totalItem: 'Total del ítem',
    adicionarItem: 'Agregar ítem',
    removerItem: 'Quitar ítem',
    somaItens: 'Suma de los ítems',
    condicao: 'Condición',
    condicoes: { avista: 'Al contado', mensal: 'Cuotas mensuales', prazos: 'Plazos en días' },
    parcelas: 'Cuotas',
    prazos: 'Plazos',
    prazosAjuda: '30, 30/60 o 30/60/90: contados desde el primer vencimiento',
    primeiroVencimento: 'Primer vencimiento',
    forma: 'Forma de pago',
    formas: { pix: 'Pix', boleto: 'Boleto', transferencia: 'Transferencia', cartao_credito: 'Tarjeta de crédito', cartao_debito: 'Tarjeta de débito', dinheiro: 'Efectivo', cheque: 'Cheque', outro: 'Otro' },
    observacoes: 'Observaciones',
    previa_one: '{{count}} cuenta por pagar: {{valores}}',
    previa_other: '{{count}} cuentas por pagar: {{valores}}',
    previaVazia: 'Indica el valor para ver las cuotas',
    salva: 'Compra registrada. Se generaron las cuentas por pagar.',
    contas: 'Cuentas por pagar generadas',
    parcela: 'Cuota {{parcela}} de {{parcelas}}',
    venceEm: 'vence el {{data}}',
    verNoContas: 'Ver en Cuentas por pagar',
    itens: 'Ítems',
    semItens: 'Sin ítems: la compra se registró por el total.',
    cancelar: 'Cancelar compra',
    cancelarTitulo: 'Cancelar compra',
    cancelarTexto: 'Las cuentas por pagar abiertas y sin pago se cancelan. Las que ya tienen pago quedan como están: corrígelas con la reversión en Finanzas. No se borra nada.',
    motivo: 'Motivo de la cancelación',
    excluir: 'Eliminar compra',
    excluirTitulo: '¿Eliminar esta compra?',
    excluirTexto: 'La compra cancelada va a la papelera por 30 días y puede volver como estaba. Sus cuentas por pagar en Cuentas no cambian.',
    excluida: 'Compra eliminada. Se puede deshacer desde la Papelera en hasta 30 días.',
    cancelada: 'Compra cancelada: {{canceladas}} cuenta(s) cancelada(s), {{mantidas}} con pago mantenida(s)',
    estado: { ativa: 'Activa', cancelada: 'Cancelada' },
    estadoConta: { em_aberto: 'Abierta', parcial: 'Pagada en parte', pago: 'Pagada', cancelado: 'Cancelada' },
    canceladaEm: 'Cancelada el',
    vazio: 'Registra aquí lo que la empresa compra: servicio, material o cuenta. Las cuentas por pagar salen listas.',
    vazioFiltro: 'Ninguna compra con estos filtros.',
    todosEstados: 'Todos los estados',
    tipoFiltro: { rotulo: 'Tipo', todos: 'Productos y servicios', produto: 'Producto', servico: 'Servicio' },
    erros: {
      fornecedor: 'Elige el proveedor',
      descricao: 'Describe la compra',
      valor: 'Indica el valor total o los ítems',
      item: 'Describe cada ítem e indica cantidad y valor',
    },
  },
  historico: {
    simplificado: 'Historial del flujo detallado. En el modo simplificado queda solo para consulta; para usar requisición, cotización, pedido y recepción, cámbialo en Configuración > Modo de operación.',
    verHistorico: 'Ver historial del flujo detallado',
    semEstoque: 'Inventario no está instalado: la recepción confirma el pedido y genera la cuenta por pagar, sin entrada de mercadería en el stock.',
  },
  c3: {
    tipo: 'Tipo de compra',
    tipos: { servico: 'Servicio (NFS-e)', produto: 'Producto (NF-e de entrada)' },
    tipoLista: { servico: 'Servicio', produto: 'Producto' },
    prestador: 'Prestador del servicio',
    emitente: 'Emisor (proveedor)',
    empresa: 'Empresa',
    empresaAjuda: 'Para cambiarla, usa el filtro de empresa arriba.',
    numeroCompra: 'Número de compra',
    numeroGerado: 'Se genera al guardar',
    nfServico: 'Factura de servicio (NFS-e)',
    nfProduto: 'Factura de producto (NF-e)',
    nfNumero: 'Número de la factura',
    nfEmissao: 'Fecha de emisión',
    discriminacaoServico: 'Detalle del servicio',
    produtosItens: 'Productos / ítems',
    descricaoServico: 'Detalle del servicio',
    descricaoProduto: 'Naturaleza de la operación / descripción',
    servicoContratado: 'Servicio contratado',
    novoServicoContratado: 'Nuevo servicio',
    qtd: 'Cant.',
    vlrUnit: 'Valor unit.',
    valor: 'Valor',
    valoresImpostos: 'Valores e impuestos',
    impostosAviso: 'Los impuestos no se detallan: informa el valor total de la factura.',
    datas: 'Fechas',
    primeiroVencimento: '1.er vencimiento',
    condicoesPagamento: 'Condiciones de pago',
    duplicatas: 'Cuotas',
    numeroParcelas: 'Número de cuotas',
    classificacao: 'Clasificación financiera',
    planoContas: 'Plan de cuentas',
    contaBancaria: 'Cuenta bancaria',
    contaBancariaAjuda: 'Pasa a ser la cuenta prevista en las cuentas por pagar y se sugiere al pagar.',
    previa: { parcela: 'Cuota', vencimento: 'Vencimiento', valor: 'Valor', total: 'Total' },
    entradaEstoque: 'Los ítems con producto entran en el Inventario al guardar (costo = valor unitario).',
    contaPrevista: 'Cuenta prevista',
    salvaEstoque: 'Compra registrada. Se generaron las cuentas por pagar y los productos entraron en el Inventario.',
    contratadoCriado: 'Servicio registrado y elegido en el ítem.',
  },
  w25: {
    forma: 'Forma de pago',
    minimo: 'Pedido mínimo',
    minimoInfo: 'Pedido mínimo de este proveedor: {{valor}}.',
    minimoAviso: 'El total está por debajo del pedido mínimo de este proveedor ({{valor}}). Puedes guardar igual.',
    condicoesNaFicha: 'Las condiciones están en la ficha del proveedor en Registros; editar aquí o allá cambia el mismo dato.',
    produto: 'Producto',
    novoServico: 'Nuevo servicio',
    novoProduto: 'Nuevo producto',
    servicoCriado: 'Servicio registrado en el catálogo y elegido en el ítem.',
    produtoCriado: 'Producto registrado en Inventario y elegido en el ítem.',
    semEstoqueRecebimento: 'Sin Inventario, nada entra al stock: la recepción confirma el pedido y genera la cuenta por pagar.',
  },
};

export const i18nCompra = { pt, en, es };
